"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function sanitizeBoundaryName(name) {
    return name
        .replace(/[\\/\s]+/g, ".") // Convert slashes and spaces to dots
        .replace(/[^a-zA-Z0-9\\.]/g, "") // Remove all non-alphanumeric characters except dots
        .replace(/\.{2,}/g, ".") // Replace multiple periods with a single period
        .replace(/^\.+|\.+$/g, ""); // Remove leading and trailing periods
}
exports.default = sanitizeBoundaryName;
